import React from 'react';
import PropTypes from 'prop-types';

import { ReviewList } from 'Components/organisms/ReviewList';

export const getReviewList = ({
  extraClassNames,
  overallRating,
  overallRatingLabel,
  showTextRating,
  summary,
  title,
}) => (
  <ReviewList
    extraClassNames={extraClassNames}
    overallRating={overallRating}
    overallRatingLabel={overallRatingLabel}
    showTextRating={showTextRating}
    summary={summary}
    title={title}
  />
);

getReviewList.propTypes = {
  title: PropTypes.string,
  overallRatingLabel: PropTypes.string,
  overallRating: PropTypes.number,
  showTextRating: PropTypes.bool,
  summary: PropTypes.string,
  extraClassNames: PropTypes.shape(),
};

getReviewList.defaultProps = {
  title: '',
  overallRatingLabel: '',
  overallRating: null,
  showTextRating: false,
  summary: null,
  extraClassNames: {},
};
